/* ============
 * User Transformer
 * ============
 *
 * The transformer for a user.
 */

import Transformer from './Transformer';

export default class UserTransformer extends Transformer {


  /**
   * Method used to transform a fetched user.
   *
   * @param user The fetched user.
   *
   * @returns {Object} The transformed user.
   */
  static fetch(user) {
    return {
      id: user.id,
      name: user.name,
      firstName: user.firstName,
      email: user.email,
      userOrg: user.userOrg,
      visuOrgs: user.visuOrgs,
      customerOrgId: user.customerOrgId,
    };
  }

  /**
   * Method used to transform a send a rule.
   *
   * @param user The rule to be send.
   *
   * @returns {Object} The transformed rule.
   */
  static send(user) {
    return {
      userId: user.id ? user.id : undefined,
      login: user.login ? user.login : undefined,
      password: user.password ? user.password : undefined,
      firstName: user.firstName ? user.firstName : undefined,
      name: user.lastName ? user.lastName : undefined,
      email: user.email ? user.email : undefined,
      userOrgId: user.userOrgId,
      visuOrgIds: user.visuOrgIds,
      customerOrgId: user.customerOrgId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/UserTransformer.js